import React from "react";
import './BotButton.css';

import { BsRobot } from "react-icons/bs";

const BotButton = (props) => {
    return(
        <div className="avatar-icon-btn" onClick={ ()=>{ props.open() } }>
            <BsRobot className="avatar-icon" />
        </div>
    )
}

export default BotButton;
